import { BasedObservedViewModel } from "app/based/basedObservedViewModel/BasedObservedViewModel";
import { VnskySupportOcsInfoInjection } from "features/vnskySupportOcsInfo/di/VnskySupportOcsInfoInjection";
import { VnSkyOscLookupRequestEntity } from "features/vnskySupportOcsInfo/domain/entities/VnSkyOscLookupRequestEntity";
import { VnSkyOscLookupResponseEntity } from "features/vnskySupportOcsInfo/domain/entities/VnSkyOscLookupResponseEntity";
import { BehaviorSubject } from "rxjs";
import { injectable } from "tsyringe";
import { strings } from "utils/localizedStrings";
import { IVnSkyOscObservedState } from "../interfaces/IVnskySupportOcsInfo";

class VnskySupportOcsInfoInput implements Disposable {
  public fetchInfo = new BehaviorSubject<VnSkyOscLookupRequestEntity>({});
  public loading = new BehaviorSubject<boolean>(false);

  [Symbol.dispose](): void {
    this.fetchInfo.complete();
    this.loading.complete();
  }
}

class VnskySupportOcsInfoOutput implements Disposable {
  public onError = new BehaviorSubject<string>("");
  public onGetDetailSuccess = new BehaviorSubject<boolean>(false);

  [Symbol.dispose](): void {
    this.onError.complete();
    this.onGetDetailSuccess.complete();
  }
}

@injectable()
export class VnskySupportOcsInfoViewModel extends BasedObservedViewModel<
  VnskySupportOcsInfoInput,
  VnskySupportOcsInfoOutput,
  IVnSkyOscObservedState
> {
  private useCase = VnskySupportOcsInfoInjection.getUseCase();
  protected override createObservedState(): IVnSkyOscObservedState {
    return {
      loading: false,
      result: {},
    };
  }

  constructor() {
    super(new VnskySupportOcsInfoInput(), new VnskySupportOcsInfoOutput());
  }

  private sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  protected override transform(): void {
    this.skipFirstInitial(this.input.fetchInfo, async (params) => {
      try {
        this.setObservedState({ loading: true });
        const res = await this.useCase.lookupOsc(params);
        if (res?.data) {
          this.setObservedState({
            result: new VnSkyOscLookupResponseEntity(res?.data),
          });
          this.output.onGetDetailSuccess.next(true);
        }
      } catch (error) {
        console.error(error);
        this.output.onError.next(
          strings.OscLookupFeature.Messages.LookupFailed,
        );
      } finally {
        this.setObservedState({ loading: false });
      }
    });
  }
}
